import { Button } from './Button'
import { Logo } from './Logo'

interface Props {
  onRequest: () => void
}

export function CapabilityStatement({ onRequest }: Props) {
  return (
    <section id="capability" className="bg-white py-20 lg:py-24 scroll-mt-16">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="font-data text-xs uppercase tracking-wide text-mint font-medium">
              Capability Statement
            </div>
            <h2 className="mt-3 text-3xl sm:text-4xl font-semibold text-navy tracking-tight">
              The artifact your capture team needs.
            </h2>
            <p className="mt-4 text-base text-navy/70">
              Drop-ready capability statement for federal bids. Eight pages, structured
              for procurement review and capture-package assembly.
            </p>
            <ul className="mt-6 space-y-2 text-sm text-navy/80">
              <li className="flex gap-3">
                <span className="text-mint mt-1">●</span>
                <span>FedRAMP High Ready authorization status; pursuing Authorization.</span>
              </li>
              <li className="flex gap-3">
                <span className="text-mint mt-1">●</span>
                <span>Advisory board: Sienkiewicz · Roat · Blair · Grady.</span>
              </li>
              <li className="flex gap-3">
                <span className="text-mint mt-1">●</span>
                <span>DISA RFI-VIRTUALIZATION-2026 response summary.</span>
              </li>
              <li className="flex gap-3">
                <span className="text-mint mt-1">●</span>
                <span>Reference architecture and per-node SKU pricing bands.</span>
              </li>
            </ul>
            <div className="mt-8">
              <Button onClick={onRequest} variant="secondary" size="lg">
                Send me the capability statement
              </Button>
            </div>
          </div>
          <div className="hidden lg:block">
            <div className="bg-navy text-white rounded-card p-8 shadow-card relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-mint/10 rounded-full -translate-y-12 translate-x-12" />
              <div className="absolute top-6 right-6 z-10">
                <Logo height={24} variant="dark" showWordmark={false} />
              </div>
              <div className="font-data text-xs uppercase tracking-wide text-mint/80 relative">
                Federal Capability Statement
              </div>
              <div className="mt-2 text-2xl font-semibold relative">
                CyCloud — operated by CyLogic
              </div>
              <div className="mt-6 space-y-3 text-sm text-white/85 font-data relative">
                <div>· DUNS / UEI · CAGE Code</div>
                <div>· NAICS codes · Federal vehicles</div>
                <div>· Past performance · Teaming posture</div>
                <div>· Reference architecture · SKU bands</div>
                <div>· Compliance posture · Roadmap</div>
              </div>
              <div className="mt-8 pt-6 border-t border-white/15 text-xs text-white/55 relative">
                Gated — request via form. We'll email it within one business day.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
